import { Typography, IconButton, Button,Paper } from '@mui/material'
import { Box } from '@mui/system'
import React from 'react'
import { makeStyles } from 'tss-react/mui'
import { FiltChip, FiltSelect } from './filtercomp'
import { ngStates, PropertyType, pxToRem } from '@/util'
import { PriceRange } from '@/util/types/investment'

type props={
    handleClose:()=>void,
    setLocation:(value:string)=>void,
    location:string,
    propertyType:string,
    setPropertyType:(value:string)=>void,
    sort:string,
    setSort:(value:string)=>void,
    isLocation:boolean,
    isPropertyType:boolean,
    isPriceRange:boolean,
    isStatus:boolean,
    isSort:boolean,
    priceRange:string,
    setPriceRange:(value:string)=>void,
    handleSearch:()=>void,
    statusData:{label:string,value:string}[],
    setStatus:(value:string)=>void,
    status:string
}
export default function PortfolioFilter({setStatus,statusData,status,priceRange,setPriceRange,isLocation=true,isPropertyType=true,isPriceRange=true,isStatus=true,isSort=true,handleClose,setLocation,location,propertyType="",setPropertyType,sort,setSort,handleSearch}:Partial<props>) {
  
    const {classes}=styles();
    const close=()=>{
        if(handleClose)handleClose();
    }
    const search=()=>{
     if(handleSearch)handleSearch();
     if(handleClose)handleClose();
    }
  return (
   <Paper className={classes.container}>
    <Box className={classes.head}>
        <Typography className={classes.filtxt}>Filter</Typography>
        <IconButton onClick={()=>close()}>
            <Typography className={classes.filtxt}>Close</Typography>
        </IconButton>
    </Box>
    <Box className={classes.sub}>
      {isLocation&&<FiltSelect 
      name="Location" 
      placeholder="Select Location" 
      data={ngStates.map((item) => ({ value: item.name, label: item.name }))}
      handleChange={(e)=>setLocation&&setLocation(e.target.value)}
      value={location}
      /> }
      {isPropertyType&&<FiltChip name="Property Type" setPropertyType={(e)=>setPropertyType&&setPropertyType(e)} data={Object.keys(PropertyType).map(key => ({ label: key, isSelected: propertyType === key }))}/>
      }
      {isPriceRange&&<FiltSelect 
      name="Price Range" 
      placeholder="Price Range" 
      data={PriceRange.map((item) => ({ value: item.value, label: item.label }))}
      handleChange={(e)=>setPriceRange&&setPriceRange(e.target.value)}
      value={priceRange}
      /> }
      {isStatus && statusData && (
        <FiltChip name="Status" setPropertyType={(e)=>setStatus&&setStatus(e)} data={statusData.map((item) => ({ label: item.label, isSelected: item.value === status }))} />
      )}
      {isSort&& <FiltChip
       name="Sort Option"
       data={['newest','oldest'].map((value)=>({label:value,isSelected:sort===value}))}
       setPropertyType={(e)=>setSort&&setSort(e)}
        />}
      <Button className={classes.btn}  variant="contained" onClick={()=>search()}>Apply</Button>
    </Box>
   </Paper>
  )
}
const styles=makeStyles()((theme)=>({
   
    head:{
        display:'flex',
        flexDirection:'row',
        justifyContent:'space-between'
    },
    filtxt:{
   fontWeight: 500,
   fontSize: pxToRem(16)
   
    },
    btn:{
        height:pxToRem(46),
        borderRadius:pxToRem(8),
    },
    container:{
        padding:theme.spacing(4),
        borderRadius:pxToRem(8),
        display:'flex',
        flexDirection:'column',
        gap:theme.spacing(2),
    },
    sub:{
        display:'flex',
        flexDirection:'column',
        gap:theme.spacing(4)
    }
}))
 